import { connect } from "react-redux";
import AchievementsTeamsLiveUpdate from "./LiveUpdate.jsx";
import { fetchLiveUpdateAction } from "../liveUpdateActions";

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    ...state.liveUpdate,
    smallIcons:
      state.games.current.sport === "americanfootball" ||
      state.games.current.sport === "basketball",
    displaySquareBorder: state.games.current.sport === "soccer" ? false : true,
    classification: state.classifications.current || null
  };
};
const mapDispatchToProps = dispatch => {
  return {
    load: classification => dispatch(fetchLiveUpdateAction(classification))
  };
};

const AchievementsTeamsLiveUpdateContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AchievementsTeamsLiveUpdate);

export default AchievementsTeamsLiveUpdateContainer;
